let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hwiu3")).then(() => parcelRequire('jUOfU'));